import { useBoolean } from '../../../../../utils/hooks/useBoolean';
import { useCallback, useRef, useState } from 'react';
import { getFileExtensionFromURL, isItemRenamable } from '../../../../../utils/media-manager-sdk/items';
import { stopPropagation } from '../../../../../utils/dom/domEvents';

export const useRenameItemHandlers = ({ item, onRenameComplete }) => {
  const { value: isEditing, setTrue: startEditing, setFalse: stopEditing } = useBoolean(false);
  const [editingName, updateEditingName] = useState(null);

  const handleNameClick = useCallback(
    (event) => {
      if (isItemRenamable(item)) {
        startEditing();
        updateEditingName(item.name);
        stopPropagation(event);
      }
    },
    [item],
  );

  const handleNameChange = useCallback((event) => updateEditingName(event.target.value), []);

  const handleRenameCancel = useCallback(() => {
    updateEditingName(item.name);
    stopEditing();
  }, [item.name]);

  const handleRenameComplete = useCallback(() => {
    onRenameComplete(editingName);
    stopEditing();
  }, [editingName]);

  const inputRef = useRef(null);
  const handleInputFocus = useCallback(() => {
    setTimeout(() => {
      if (!inputRef.current) {
        return;
      }

      const ext = getFileExtensionFromURL(item.name);
      inputRef.current.input.setSelectionRange(0, item.name.length - (ext ? ext.length + 1 : 0));
    }, 0);
  }, [item.name]);

  return {
    isEditing,
    editingName,
    inputRef,
    handleInputFocus,
    handleRenameComplete,
    handleRenameCancel,
    handleNameChange,
    handleNameClick,
  };
};
